import { IResponse } from '@estee/elc-http-transport';

import { IPGResponse } from '~api/CartAPI/ICartApiSdk';

export const parseRecommendedProductIds = (
    recommendedItems: IResponse<IPGResponse<string>[]>
): string[] =>
    JSON.parse(recommendedItems?.data?.[0]?.result?.value as string)?.results?.reduce(
        (accum: string[], { id }: { id: string }) => [...accum, id],
        []
    );
